module.exports = __webpack_public_path__ + "img/Lake_rengen.736378e7.jpg";